import { inject, injectable } from 'inversify';
import { contest, contest_all, contest_dto } from '@Api';
import { Contest, EntityVersioning, Nullable, VersionGame } from '@Models';
import { IMapper } from '../IMapper';
import { ContestParticipationMode } from '@Models';
import { TYPES } from '@Types';
import { VersionGameMapper } from '../ninthAge/VersionGameMapper';

@injectable()
export class ContestMapper
  implements IMapper<string, contest, contest, Contest>
{
  @inject(TYPES.Mapper.VersionGameMapper)
  private _versionGameMapper!: VersionGameMapper;

  public map(item: contest_all): Contest {
    return {
      id: item.id,
      name: item.name,
      versionId: 0,
      game: VersionGame.NinthAge,
      startDate: new Date(0),
      endDate: null,
      updatedAt: item.updated_at,
      participation: ContestParticipationMode.INDIVIDUAL,
      userMax: 0,
      teamMax: 0,
      armyListMax: 0,
      showAllArmies: false,
    } satisfies Contest as Contest;
  }

  public mapFull(item: contest): Contest {
    return {
      id: item.id,
      name: item.name,
      versionId: item.version_id,
      game: this._versionGameMapper.map(item.game),
      startDate: new Date(item.start_date * 1000),
      endDate: item.end_date ? new Date(item.end_date * 1000) : null,
      updatedAt: item.updated_at,
      participation: this.mapParticipation(item.participation),
      userMax: item.user_max,
      teamMax: item.team_max,
      armyListMax: item.army_list_max,
      showAllArmies: item.show_all_armies,
    } satisfies Contest as Contest;
  }

  mapDto(contest: Contest): contest_dto {
    return {
      name: contest.name,
      start_date: contest.startDate.getTime() / 1000,
      end_date: contest.endDate ? contest.endDate.getTime() / 1000 : null,
      version_id: contest.versionId,
      participation: this.mapParticipationDto(contest.participation),
      user_max: contest.userMax,
      team_max: contest.teamMax,
      army_list_max: contest.armyListMax,
    };
  }

  mapVersioning(data: any): Nullable<EntityVersioning<string>> {
    return null;
  }

  private mapParticipation(
    participation: contest.participation,
  ): ContestParticipationMode {
    switch (participation) {
      case contest.participation.TEAM:
        return ContestParticipationMode.TEAM;
      default:
        return ContestParticipationMode.INDIVIDUAL;
    }
  }

  private mapParticipationDto(
    participation: ContestParticipationMode,
  ): contest.participation {
    switch (participation) {
      case ContestParticipationMode.TEAM:
        return contest.participation.TEAM;
      default:
        return contest.participation.INDIVIDUAL;
    }
  }
}
